import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { SegmentService } from 'src/app/services/segment.service';

@Component({
  selector: 'app-list-segment-type',
  templateUrl: './list-segment-type.component.html',
  styleUrls: ['./list-segment-type.component.css']
})
export class ListSegmentTypeComponent implements OnInit {


  eventsSubject: Subject<any> = new Subject<any>();


  displayedColumns: string[] = ['name','typesSegment', 'description', 'status', 'actions'];
  columnsToDisplay = [{field: 'name', header: 'Nome', type: 'text'}, {field: 'description', header: 'Descrição', type: 'text'}, {field: 'typesSegment', header: 'Identificador', type: 'text'}];
  columnsObject = [];
    columnsBadge = [{field: 'status', header: 'Estado', type: 'select', selectFieldsDados:  [ {name: 'Ativo', val: 'ACTIVE'}, {name: 'Inativo', val: 'INACTIVE'}]}];
    options = {edit: true, view: true, delete: true, statusUpdate: true};
  title = 'Tipo de Segmentos';
  novo = {link: '/tipos-segmentos/criar', nome: 'Novo Tipo Segmento'};
  page: any = {base: null, name: null};
  service;

  constructor(private storeService: StoreService,
    private route: ActivatedRoute,
    private segmentService: SegmentService,
    private confirmationDialogService: ConfirmationDialogService,
    private toast: ToastrService,
    private router: Router,) {
this.service = this.segmentService.getAllTypes;
}

ngOnInit(): void {
  this.page.base = this.route.data['value'].base;
  this.page.name = this.route.data['value'].routeName;
  }

  edit = (args: any): void => {
    console.log(args);
    this.router.navigate([this.page.base  + '/editar'], { queryParams: { id: args.id } });
    }
    view = (args: any): void => {
      console.log(args);
      this.router.navigate([this.page.base  + '/view'], { queryParams: { id: args.id } });
    }
    changeStatus = (args: any): void => {
    let textConfirm = '';
    let status = '';
    let textShow = '';

    let service;
    if (args.status === 'ACTIVE'){
      service = this.segmentService.inactiveType(args.id);
      textConfirm = 'Pretende Desactivar o tipo Segmento ' + args.name + '? Ao desactivar o Segmento o estado do Segmento será alterado para INATIVO e não aparecerá nos formulários.';
      status = 'INACTIVE';
      textShow = 'TIPO DE SEGMENTO DESATIVADO COM SUCESSO';
    }
    else{
      service = this.segmentService.activeType(args.id);
      textConfirm = 'Pretende Activar o tipo de Segmento ' + args.name + '? Ao activar o tipo Segmento o estado da Segmento será alterado para ATIVO e aparecerá nos formulários';
      status = 'ACTIVE';
      textShow = 'TIPO DE SEGMENTO ACTIVADO COM SUCESSO';
    }

    this.confirmationDialogService.confirm('Por favor confirme', textConfirm)
    .then((confirmed) =>
    {
      if (confirmed){
        service.subscribe((event: any) => {
          this.toast.warning(textShow, 'Mudança de Estado');
          args.status = status;
      });
      }
    }
    )
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

    delete = (total: any, args: any, index: number): void => {
      this.confirmationDialogService.confirm('Por favor confirme', 'Pretende apagar este Tipo de Segmento ' + args.name + '? Ao eliminar os dados do Tipo de Segmento serão perdidos!!')
      .then((confirmed) =>
      {
        if (confirmed){
          const indexo = total.indexOf(args);
          this.segmentService.deleteType(args.id).pipe(first())
      .subscribe(
          data => {
            this.toast.warning('Eliminado com sucesso', 'Delete');
            total.splice(indexo, 1);
            console.log('total', total);
            this.eventsSubject.next(total);
          },
          error => {
              console.log('error', error);
          });
        }
      }
      )
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      console.log(args);
    }

  }
